// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I3qN","toggleWrap":"styles_toggleWrap__14Lbv","content":"styles_content__9IlkC","selectAreaCode":"styles_selectAreaCode__W4lrD"};